import React, { Component } from 'react';
// import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import axios from 'axios';

class SignupBox extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {
      email: '',
      disabled: false
    };
  }
  handleSubmit() {
    // console.log('call revue', this.state.email);
    const savedEmail = this.state.email;
    const emailRegex = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
    const emailStatus = emailRegex.test(savedEmail);
    const data = {
      email: savedEmail,
      first_name: 'new',
      last_name: 'user',
      double_opt_in: false
    };

    if (emailStatus) {
      const webApiUrl = 'https://www.getrevue.co/api/v2/subscribers';
      const tokenStr = 'iHKTPKgaDUSYFKnbsZlEnbPT119pM-3e';
      axios
        .post(webApiUrl, data, {
          headers: {
            Authorization: `Token ${tokenStr}`
          }
        })
        .then(response => {
          // console.log(response);
          if (response.status === 200) {
            this.setState({
              disabled: true,
              email: "You're Subscribed!"
            });
          }
        })
        .catch(err => {
          // console.log('AXIOS ERROR: ', err.response);
          this.setState({
            disabled: false,
            email:
              err.response.data.error.email[0] ===
              'This email address has already been subscribed'
                ? 'Already Subscribed'
                : err.response.data.error.email[0]
          });
        });
    } else {
      this.setState({
        disabled: false,
        email: 'Please Try Again'
      });
    }
  }

  render() {
    return (
      <center>
        <div className="signup-box">
          <div className="__box-left">
            <img
              alt="compass_logo"
              src="https://images.fastcompany.net/image/upload/v1556587129/fcweb/fc_compass_big_n6v2nh.png"
            />
          </div>
          <div className="__box-right">
            <span className="__dek">
              <b className="heading">Navigate smart.</b> Sign up for our new
              daily email.
            </span>
            <div className="__input-div">
              <input
                className="__email-input"
                type="text"
                onChange={e => {
                  this.setState({ email: e.target.value }, () => {
                    // console.log(this.state.email);
                  });
                }}
                value={this.state.email}
                disabled={this.state.disabled ? 'disabled' : ''}
              />
              <input
                className="__button"
                type="button"
                value="SUBMIT"
                onClick={this.handleSubmit}
                disabled={this.state.disabled ? 'disabled' : ''}
              />
            </div>
          </div>
        </div>
      </center>
    );
  }
}

// SignupBox.propTypes = {
//   name: PropTypes.string.isRequired,
//   desc: PropTypes.string.isRequired,
//   lists: PropTypes.arrayOf(PropTypes.number).isRequired,
//   choices: PropTypes.arrayOf(PropTypes.string),
//   checked: PropTypes.arrayOf(PropTypes.bool).isRequired,
//   onChange: PropTypes.func.isRequired,
//   handleNewslettersRadioUpdate: PropTypes.func,
//   isRadio: PropTypes.bool
// };

function mapStateToProps(state) {
  return {
    config: state.config,
    currentSite: state.config.site
    // assignedNewsletters: assignedNewsletters.map(
    //   function processAssignedNewsletters(newsletter) {
    //     const newsletterNameProp = newsletter.list;
    //     const listId = get(newslettersBySlug, newsletterNameProp);
    //     const found = newsletterDictionary[listId];
    //     return {
    //       listName: get(found, 'listName'),
    //       listId,
    //       message: get(found, 'short')
    //     };
    //   }
    // )
  };
}

export default connect(mapStateToProps)(SignupBox);
